import { Component } from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

@Component({
    'selector': 'app-crmProspects',
    'templateUrl': './crmProspects.page.html',
    'styleUrls': ['./crmProspects.page.scss'],
    'standalone': true,
    'imports': [IonicModule, CommonModule, FormsModule]
})
export class CrmProspectsPage {

    // constructor() { }

}
